import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import '@mdi/font/css/materialdesignicons.css';
// Import Firebase configuration
import { app as firebaseApp } from './firebase';


console.log('Firebase initialized:', firebaseApp);


loadFonts()


// Create Vue app
const app = createApp(App);

app
.use(vuetify)
.mount('#app')
